import React from 'react';
import { Alert, Container, Grid } from '@iho-design-system/Loader';
import List from '../components/favorite/List';
import Toolbar from '../components/favorite/Toolbar';
import getAPI from '../api/get';

const Favorite = () => {
  const [favoritesData, setFavoritesData] = React.useState({ favorites: '' });
  const [reloadFavorite, setReloadFavorite] = React.useState('');
  const [hotelNameSearchKey, setHotelNameSearchKey] = React.useState('');
  const [alert, setAlert] = React.useState('');
  const [alertColor, setAlertColor] = React.useState('success');
  const [alertStatus, setAlertStatus] = React.useState('d-none');

  const alertProps = (config) => {
    setAlert(config[1]);
    setAlertColor(config[0]);
    setAlertStatus('d-flex');
    setTimeout(() => setAlertStatus('d-none'), 2500);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const favoritsParameters = {
        ctrl: 'UserProfile',
        method: 'GetFavorites',
        query: ''
      };
      const favorites = await getAPI(favoritsParameters);
      setFavoritesData({ favorites });
    };
    fetchData();
  }, [reloadFavorite]);

  const reloadFavoriteProps = (reloadFavoriteProps) => setReloadFavorite(reloadFavoriteProps);
  const hotelNameSearchProps = (key) => setHotelNameSearchKey(key);

  const listData = {
    favorites: favoritesData.favorites,
    hotelNameSearchKey
  };

  return (
    <>
      <Container size='lg'>
        <Grid>
          <Grid.Wrapper>
            <Grid.Item className='pr-0 pl-0' size='col-12'>
              <Toolbar hotelNameSaerchPrps={hotelNameSearchProps} />
            </Grid.Item>
            <Grid.Item className='pr-0 pl-0' size='col-12'>
              <List
                props={listData}
                alertProps={alertProps}
                reloadFavoriteProps={reloadFavoriteProps}
              />
            </Grid.Item>
          </Grid.Wrapper>
        </Grid>
      </Container>
      <Alert
        className={`alert ${alertStatus}`}
        color={alertColor}
        ms={{ bottom: '75px !important' }}
      >
        {alert}
      </Alert>
    </>
  );
};

export default Favorite;
